var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpeningCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#EEFBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8871 48.8637C44.8871 51.6879 47.1765 53.9773 50.0007 53.9773C52.8249 53.9773 55.1144 51.6879 55.1143 48.8637C55.1143 46.0395 52.8249 43.75 50.0007 43.75C47.1765 43.75 44.8871 46.0395 44.8871 48.8637Z",
    fill: "#84CC6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3137 63.2407C33.6067 64.7728 36.7986 64.7728 43.1825 64.7728L56.8189 64.7728C63.2028 64.7728 66.3948 64.7728 68.6877 63.2407C69.6804 62.5774 70.5326 61.7251 71.1959 60.7325C72.728 58.4396 72.728 55.2476 72.728 48.8637C72.728 42.4798 72.728 39.2878 71.1959 36.9949C70.5326 36.0022 69.6804 35.1499 68.6877 34.4867C66.3948 32.9546 63.2028 32.9546 56.8189 32.9546H43.1825C36.7986 32.9546 33.6066 32.9546 31.3137 34.4867C30.3211 35.1499 29.4688 36.0022 28.8055 36.9949C27.2734 39.2878 27.2734 42.4798 27.2734 48.8637C27.2734 55.2476 27.2734 58.4396 28.8055 60.7325C29.4688 61.7251 30.3211 62.5774 31.3137 63.2407ZM50.0007 57.3864C45.2937 57.3864 41.478 53.5707 41.478 48.8637C41.478 44.1567 45.2937 40.341 50.0007 40.341C54.7077 40.341 58.5234 44.1567 58.5234 48.8637C58.5234 53.5707 54.7077 57.3864 50.0007 57.3864ZM35.228 57.3864C34.2866 57.3864 33.5234 56.6233 33.5234 55.6819L33.5234 42.0455C33.5234 41.1041 34.2866 40.341 35.228 40.341C36.1694 40.341 36.9325 41.1041 36.9325 42.0455L36.9325 55.6819C36.9325 56.6233 36.1694 57.3864 35.228 57.3864ZM63.0689 55.6819C63.0689 56.6233 63.832 57.3864 64.7734 57.3864C65.7148 57.3864 66.478 56.6233 66.478 55.6819V42.0455C66.478 41.1041 65.7148 40.341 64.7734 40.341C63.832 40.341 63.0689 41.1041 63.0689 42.0455V55.6819Z",
    fill: "#84CC6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningCashIcon);
export default __webpack_public_path__ + "static/media/opening_cash_icon.5bf62cf2003cd810196869301b39e61c.svg";
export { ForwardRef as ReactComponent };